/**
 * Подписи и классы вкладки «Подписка», общие для экрана и его скелетона.
 *
 * Скелетон рисует статичный текст настоящим (заголовки, пояснения, подписи полей), а
 * данные — плашками. Чтобы при появлении данных ничего не сдвинулось, текст и классы
 * раскладки берутся отсюда и там и там: поправленная в одном месте подпись в две строки
 * вместо одной иначе сразу разводит скелетон с экраном по высоте.
 */
export const SUBSCRIPTION_COPY = {
  balanceTitle: 'Баланс',
  activeTitle: 'Текущая подписка',
  activeBadge: 'Активна',
  expiringBadge: 'Скоро истекает',
  activeFrom: 'Действует с',
  activeTo: 'Действует до',
  plan: 'Тариф',
  inactiveTitle: 'Подписка не активна',
  inactiveHint: 'Сначала пополните баланс по СБП, затем подключите тариф с кошелька.',
  topupTitle: 'Пополнить баланс',
  topupHint: 'Оплата по СБП. После зачисления деньги остаются на кошельке — тариф подключается отдельно.',
  amountLabel: 'Сумма, ₽',
  emailLabel: 'Email для чека',
  buyPlanTitle: 'Подключить тариф',
  buyPlanHint: 'Оплата списывается с баланса. Если средств не хватает — сначала пополните кошелёк.',
  noPlans: 'Тарифы пока недоступны.',
  selectedPlan: 'Выбран',
} as const;

/** Колонка карточек вкладки. */
export const SUBSCRIPTION_COLUMN_CLASS = 'flex max-w-md flex-col gap-4';

/** Шапка карточки активной подписки: заголовок слева, бейдж статуса справа. */
export const SUBSCRIPTION_HEADER_CLASS = 'mb-4 flex items-center justify-between';

/** Бейдж статуса подписки без цвета фона — цвет зависит от срока. */
export const SUBSCRIPTION_BADGE_CLASS = 'rounded-full px-2 py-1 text-xs font-medium';

/** Строка «подпись — значение» в карточке подписки. */
export const SUBSCRIPTION_INFO_ROW_CLASS = 'flex items-center justify-between py-1.5';

/** Форма внутри карточки: пополнение и подключение тарифа. */
export const SUBSCRIPTION_FORM_CLASS = 'flex flex-col gap-4';

/** Список тарифов и содержимое карточки тарифа. */
export const SUBSCRIPTION_PLAN_LIST_CLASS = 'flex flex-col gap-2';
export const SUBSCRIPTION_PLAN_ROW_CLASS = 'flex items-center justify-between gap-3';
